import EntryActionTypes from '../../constants/EntryActionTypes';

export const createFactory = (data) => ({
  type: EntryActionTypes.FACTORY_CREATE,
  payload: {
    data,
  },
});

export const updateFactory = (id, data) => ({
  type: EntryActionTypes.FACTORY_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteFactory = (id) => ({
  type: EntryActionTypes.FACTORY_DELETE,
  payload: {
    id,
  },
});

export const updateCurrentFactory = (data) => ({
  type: EntryActionTypes.CURRENT_FACTORY_UPDATE,
  payload: {
    data,
  },
});

export const updateCurrentFactoryBackgroundImage = (data) => ({
  type: EntryActionTypes.CURRENT_FACTORY_BACKGROUND_IMAGE_UPDATE,
  payload: {
    data,
  },
});

export const deleteCurrentFactory = () => ({
  type: EntryActionTypes.CURRENT_FACTORY_DELETE,
  payload: {},
});
